import comp from "./AddLearningGoals";
export default comp;
